import { Flow } from '@/components/Flow';
import { Step } from '@/components/Step';

export const TheEnd = () => {
  return (
    <Flow>
      <Flow.StepList>
        <Step name='the-end' />
      </Flow.StepList>
    </Flow>
  );
};
